import styled from "styled-components";

export const MenuPanelItemStyled = styled.button`
  border-radius: 25px;
  padding: 11px 11px 11px 32px;
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 12px;
  background: ${({ theme }) => theme.COLORS.PURPLE_1};
  cursor: pointer;
  .menu_panel_name {
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    font-family: ${({ theme }) =>
      `${theme.FONT.STYLE.GT_AMERICA_COMPRESSED_BOLD},${theme.FONT.STYLE.PROMPT_LIGHT}`};
  }
  &:hover {
    background: ${({ theme }) => theme.COLORS.PURPLE_10};
  }
`;
